import React from 'react';
import { ReactComponent as Facebook } from '../../assets/svg/facebook.svg';
import { ReactComponent as Linkedin } from '../../assets/svg/linkedin.svg';
import { ReactComponent as ZnanyLekarz } from '../../assets/svg/znanylekarz.svg';
import { ReactComponent as WhatsApp } from '../../assets/svg/whatsapp.svg';
import { ImageProps, SocialLinksProps } from '../../types/shared';
import { ContactItem, ContactItemProps } from './contact-item';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getWhatsappUrl } from '../../utils/getWhatsapp';
export interface ContactProps {
  items: ContactItemProps[];
  socialLinks: SocialLinksProps;
  description?: string;
  email?: string;
  phone?: string;
  image?: ImageProps;
  isWhatsApp?: boolean;
}

export const Contact: React.FC<ContactProps> = ({
  items,
  email,
  phone,
  socialLinks,
  description,
  image,
  isWhatsApp = false,
}) => (
  <div className="flex flex-col items-center gap-14 ">
    {items?.map((contact, index) => {
      if (contact.type === 'phone' && phone) {
        contact.text.data.childMdx.rawBody = phone;
      } else if (contact.type === 'email' && email) {
        contact.text.data.childMdx.rawBody = email;
      }
      return (
        <React.Fragment key={contact.label}>
          <ContactItem {...contact} />
          {index === 0 && isWhatsApp && socialLinks.whatsapp && (
            <div className="text-center flex flex-col items-center justify-center -my-8">
              <p className="uppercase text-green menu-links-16 md:h500 md:tracking-wide">
                Whatsapp Contact
              </p>
              <a
                href={getWhatsappUrl(socialLinks.whatsapp)}
                target="_blank"
                className="flex gap-2 md:gap-4 items-center"
                rel="noreferrer"
              >
                <WhatsApp className="w-12 h-12 " />
                <span className="uppercase md:normal-case h500 md:h400-normal">
                  {socialLinks.whatsapp || ''}
                </span>
              </a>
            </div>
          )}
        </React.Fragment>
      );
    })}
    {description ? (
      image ? (
        <div className="flex flex-col md:flex-row gap-8 md:gap-20 max-w-3xl mx-auto ">
          <div className={'body-s text-gray-500 flex-1'}>{description}</div>
          <div className="relative  h-full flex items-center">
            <GatsbyImage
              className="mx-auto rounded-lg max-h-[200px] w-[170px]"
              image={image?.localFile.childImageSharp.gatsbyImageData}
              objectFit="cover"
              objectPosition="50% 20%"
              alt={image?.alternativeText || image?.name || ''}
            />
          </div>
        </div>
      ) : null
    ) : null}
    <div className="flex items-center gap-5">
      {socialLinks?.facebook && (
        <a href={socialLinks.facebook} target="_blank" rel="noreferrer">
          <Facebook className="fill-brand-facebook w-9 h-9" />
        </a>
      )}
      {socialLinks?.linkedin && (
        <a href={socialLinks.linkedin} target="_blank" rel="noreferrer">
          <Linkedin className="fill-brand-linkedin w-9 h-9" />
        </a>
      )}
      {socialLinks?.znanyLekarz && (
        <a href={socialLinks.znanyLekarz} target="_blank" rel="noreferrer">
          <ZnanyLekarz className="fill-brand-znany-lekarz w-9 h-9" />
        </a>
      )}
      {socialLinks?.whatsapp && (
        <a
          href={getWhatsappUrl(socialLinks.whatsapp)}
          target="_blank"
          rel="noreferrer"
          className='drop-shadow'
        >
          <WhatsApp className="fill-brand-znany-lekarz w-10 h-10" />
        </a>
      )}
    </div>
  </div>
);
